import Vue from 'vue';
import { SubnetOperationConstant } from './Constants';

const SubnetPopHelper = {};

/**
 * 默认内容居中显示
 * 改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

export function operations(caseOps, target, param, type) {
  switch (parseInt(caseOps)) {
    // 删除子网操作
    case SubnetOperationConstant.DELETE:
      const h = target.$createElement;
      const params = {
        region: param.region,
        subnetId: param.subnetId
      };
      target.$msgbox({
        title: target.$t('subnet.text.deleteSubnet'),
        message: h('p', getClass(), [
          h('span', null, target.$t('subnet.help.confirmToDelete', [param.name])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.del('/api/cps/subnets', params)
          .then(() => {
            // 根据当前页面类型决定删除后动作
            switch (type) {
              // 列表页删除之后刷新页面
              case 'list': {
                target.updateList('refresh');
                break;
              }
              // 详情页删除之后跳转到列表页
              case 'detail': {
                target.$router.push('/subnet/list');
                break;
              }
            }
          })
          .catch(async (err) => {
            const { response } = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          });
      });
  }
}

export default SubnetPopHelper;



// WEBPACK FOOTER //
// ./src/common/SubnetPopHelper.js